import { Stripe_credit_card } from "./stripe_credit_card";

export class Stripe_customer {

    stripe_id: string;
    user_id: string;
    competition_organizer_id: string;
    first_name: string;
    last_name: string;
    telephone: string;
    email: string;
    system_customer_id: string;
    sms_customer_id: string;
    credit_card_list: Stripe_credit_card[] = [];

    constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}